import { 
  CasePermissions, 
  TextCollection, 
  RenderMode,
  CompositeKeys,
  Entity,
  StoreMetadata,
  ComplexValue,
  ChangeConnectionSequence
} from 'app/types-shared';
import { EditState } from 'app/infrastructure/ui/form/types';
import { UiSchema } from 'app/infrastructure/ui/types-uischema';
import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';

export interface CaseState {
  schema?: UiSchema;
  selectedId?: number;
  stateForCaseIds?: { 
    [caseId: string]: { valid: boolean; fetching: boolean; fetchingPermissions?: boolean; 
      permissions: CasePermissions; changeConnectionSequence?: ChangeConnectionSequence;
    }; 
  };
  entities?: { [transId: string] : Entity[] };
  texts?: TextCollection;
  editing?: EditState;
  riskMatrixDefinitions?: { [index: string]: { definition: RiskMatrixDefinition; fetching: boolean } };
  uiDefinition?: UiDefinition; // to be able to re-build the schema on demand without re-fetching
  permissions?: CasePermissions;
  renderMode?: RenderMode;
  fetching?: boolean;
  tempdata?: any;    // per-component temporary data, such as code table data
  activeChildItem?: CompositeKeys;
  metadata?: StoreMetadata;
  searchExternalProvider?: SearchExternalDataProviderState;
  viewMode?: ViewMode;
}

export interface RiskMatrixDefinition {
  type: number;
  axes: RiskMatrixAxis[];
  cells: RiskMatrixCell[];
  description?: string;
}

export interface RiskMatrixAxis {
  id: number;
  editable: boolean;
  /**
   * Fake axes are a client-only concept for supporting 1-dimensional matrix configurations.
   */
  fakeAxis?: boolean;
  data: {
    description: string;
    codetableId: number;
    options: ComplexValue<number>[];
    pleaseSelectDescription: string;
  };
}

export interface RiskMatrixCell {
  axisValues: ComplexValue<number>[];
  data: RiskMatrixCellData;
  inactive?: boolean;
}

export interface RiskMatrixCellData {
  riskArea: ComplexValue<number>;
  weight: number;
}

export enum ViewMode {
  tabs,
  scroll
}

export interface SearchExternalDataProviderState {
  fetching?: boolean;
  caseDraftId?: number;
  domainId?: number;
  searchConditions?: SearchExternalSearchCondition[];
  resultItems?: SearchExternalResultValue[][];
  error?: string;
}

export interface SearchExternalSearchCondition {
  dataTag: string;
  value: string;
}

export interface SearchExternalResultValue {
  description: string;
  dataTag: string;
  value: string;
  numberValue?: number;
  codeValue?: {
    v: number;
    d: string;
    ald?: string;
    ld?: string;
  };
  failedToMapCodeValue: boolean;
}
